import React from 'react';
import { TExtraRate } from './types';
import { ExtraRateCard } from './ExtraRateCard';

interface ExtraRatesSectionProps {
    extraRates: TExtraRate[];
    isEditing: boolean;
    onUpdateRate: (
        rateId: number,
        updater: (rate: TExtraRate) => TExtraRate,
    ) => void;
}

export const ExtraRatesSection: React.FC<ExtraRatesSectionProps> = React.memo(({
    extraRates,
    isEditing,
    onUpdateRate,
}) => {
    if (extraRates.length === 0) {
        return null;
    }

    return (
        <div className="timesheet-extra-rates">
            <h3>Additional Rates</h3>
            <div className="timesheet-booking-cards">
                {extraRates.map(rate => (
                    <ExtraRateCard
                        key={`rate-${rate.id}`}
                        rate={rate}
                        isEditing={isEditing}
                        onUpdateRate={onUpdateRate}
                    />
                ))}
            </div>
        </div>
    );
});

ExtraRatesSection.displayName = 'ExtraRatesSection';

